import axios from 'axios';

const state = {
  isShowingInfoBadge: true,
  donations: [],
};

const getters = {
  donations: (state) => state.donations,
  isShowingInfoBadge: (state) => state.isShowingInfoBadge,
};

const mutations = {
  donationsLoaded: (state, donations) => {
    state.donations = donations;
  },
  setInfoBadge: (state, value) => {
    state.isShowingInfoBadge = value;
  },
};

const actions = {
  getAll({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/donations-over-the-phone/all')
        .then(({ data }) => {
          commit(
            'donationsLoaded',
            data.sort((a, b) => {
              if (a.createdAt === undefined) {
                return -1;
              } else if (a.createdAt < b.createdAt) {
                return 1;
              } else if (a.createdAt > b.createdAt) {
                return -1;
              } else {
                return 0;
              }
            }),
          );
          resolve();
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  hideInfoBadge({ commit }) {
    commit('setInfoBadge', false);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};